import { clickstreamLogger } from '~/logging';

export const run: ITrigger = (scenarioName, configuration) => {
  let message = `Сценарий ${scenarioName} выполнен.`;

  if (configuration && typeof configuration.message === 'string') {
    message += ` Сообщение: "${configuration.message.replace(
      '%SCENARIO_NAME%',
      scenarioName
    )}"`;
  }

  clickstreamLogger.debug(message);

  return Promise.resolve('OK');
};
